import * as actions from "./action-types";
import moment from "moment";
import { generateDiscountCodeStatus } from "../../utilities/discountCodeUtils";
import { confirmPaymentStatuses, discountCodeStatuses } from "../../utilities/storeStatusDictionary";

export const initialState = {
  numberOfStudents: 0,
  isInstitution: null,
  knowsDateSelected: true,
  simulationName: "",
  startDate: moment().startOf("day"),
  endDate: moment().startOf("day").add(1, "day"),
  paymentId: "",
  purchasedSimulationName: "",
  professorAdvanceSimulation: false,
  templateName: "",
  totalSimulatedDays: null,
  discountCode: {
    status: discountCodeStatuses.initial,
    discountCode: "",
    discountCodeMessage: "",
    discountedPrice: null,
  },
  confirmPayment: {
    status: confirmPaymentStatuses.initial,
    errorMessage: "",
    paymentSummaryId: null,
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case actions.CHECK_STORAGE_INFORMATION: {
      const { discountCode, discountedPrice } = action.payload.discountCode || initialState.discountCode;
      return {
        ...state,
        ...action.payload,
        discountCode: {
          ...state.discountCode,
          discountCode: discountCode,
          discountedPrice: discountedPrice,
          status: generateDiscountCodeStatus(discountCode, discountedPrice),
        },
      };
    }
    case actions.UPDATE_INSTITUTION_STUDENTS_NUMBER:
      return {
        ...state,
        ...action.payload,
      };
    case actions.UPDATE_SIMULATION_INFORMATION:
      return {
        ...state,
        ...action.payload,
      };
    case actions.UPDATE_TRANSACTION_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case actions.VALIDATE_DISCOUNT_CODE:
      return {
        ...state,
        discountCode: {
          status: discountCodeStatuses.loading,
          discountCode: "",
          discountCodeMessage: "",
          discountedPrice: null,
        },
      };
    case actions.VALIDATE_DISCOUNT_CODE_SUCCESSFUL: {
      const { discountCode, discountedPrice } = action.payload;

      return {
        ...state,
        discountCode: {
          status: generateDiscountCodeStatus(discountCode, discountedPrice),
          discountCode: action.payload.discountCode,
          discountCodeMessage: "",
          discountedPrice: action.payload.discountedPrice,
        },
      };
    }
    case actions.VALIDATE_DISCOUNT_CODE_FAILED:
      return {
        ...state,
        discountCode: {
          ...initialState.discountCode,
          discountCodeMessage: action.payload.discountCodeMessage,
        },
      };
    case actions.RESET_QUESTIONNAIRE_STORE:
      return {
        ...initialState,
      };
    case actions.CONFIRM_PAYMENT_START: {
      return {
        ...state,
        confirmPayment: {
          status: confirmPaymentStatuses.loading,
          errorMessage: "",
          paymentSummaryId: null,
        },
      };
    }
    case actions.CONFIRM_PAYMENT_FAIL: {
      return {
        ...state,
        confirmPayment: {
          status: confirmPaymentStatuses.fail,
          errorMessage: action.payload,
          paymentSummaryId: null,
        },
      };
    }
    case actions.CONFIRM_PAYMENT_SUCCESS: {
      return {
        ...state,
        confirmPayment: {
          status: confirmPaymentStatuses.success,
          errorMessage: "",
          paymentSummaryId: action.payload,
        },
      };
    }
    case actions.RESET_DISCOUNT_CODE: {
      return {
        ...state,
        discountCode: { ...initialState.discountCode },
      };
    }
    default:
      return state;
  }
}
